import { createApp, onMounted, ref, reactive } from "../../../../../../vendor/vue/dist/vue.esm-browser.prod"
import {get} from "../../utils/data-manager";

export default class ProductList {
    constructor($element) {
        this.$element = $element;
        this.$list = this.$element.querySelector('[data-list]');
        this.createVueApp();
    }

    createVueApp() {
        const $dataScript = this.$element.querySelector('[data-list-data]');
        const initialData = JSON.parse($dataScript.textContent);

        const app = createApp({
            data() {
                return {
                    blockId: null,
                    translations: translations,
                    result: initialData,
                    availableColors: initialData.availableColors || [],
                    availableDimensions: initialData.availableDimensions || [],
                    availableStructures: initialData.availableStructures || [],
                    fetchParams: {},
                    // pager: initialData.pager,
                    publications: initialData.publications,
                    productGroups: initialData.productGroups,
                    // settings: initialData.settings,
                    abortController: null,
                    timeout: null,
                    initialized: false,
                    loader: null,
                    loading: false,
                }
            },

            watch: {
                loading() {
                    this.loader?.loading(this.loading);
                }
            },
            methods: {
                /**
                 * Active filters
                 * @param objects
                 * @param name
                 * @return {*|*[]}
                 */
                activeFilterValues(objects, name) {
                    if (! objects) {
                        return [];
                    }

                    return objects.filter( object => this.fetchParams[name].includes(object.slug));
                },
                /**
                 * Load More
                 */
                loadMore() {
                    this.setPage(this.fetchParams[translations.page] + 1, true, false);
                },
                /**
                 * Set page
                 * @param page
                 * @param keepItems
                 */
                changePage(page, keepItems = false, scrollToTop = true) {
                    this.fetchParams[translations.page] = page;
                    this.updateActiveFiltersInUrl();

                    this.fetchPublications(keepItems, scrollToTop);
                },
                /**
                 * Get the publication data
                 *
                 * @param keepItems
                 * @returns {Promise<void>}
                 */
                async fetchPublications(keepItems = false, scrollToTop = false) {
                    if(scrollToTop) {
                        this.scrollToTop();
                    }

                    const params = {
                        ...this.fetchParams
                    };
                    const url = window.location.origin + window.location.pathname + `/block/${this.blockId}/ajax`;
                    if (this.abortController) {
                        this.abortController.abort();
                    }

                    this.loading = true;
                    this.abortController = new AbortController();

                    this.result = await get(url.toString(), params, this.abortController.signal);

                    if( ! this.result) {
                        return;
                    }

                    // Set the values we need

                    this.productGroups = this.result.productGroups;

                    this.settings = this.result.settings;
                    this.pager = this.result.pager;

                    this.loading = false;

                    // bind other js logic like animate
                    this.$nextTick(() => {
                        window.initDom(this.$refs.list);
                    });
                },
                /**
                 * Add filter
                 *
                 * @param name
                 * @param value
                 */
                addFilter(name, value) {
                    this.fetchParams[name] = value;

                    this.updateActiveFiltersInUrl();
                    this.fetchPublications(false, true);
                },
                /**
                 * Add filter value
                 *
                 * @param name
                 * @param value
                 */
                addFilterValue(name, value) {
                    this.fetchParams[translations.page] = 1;
                    this.fetchParams[name].push(value);

                    this.updateActiveFiltersInUrl();
                    this.fetchPublications(false, true);
                },
                /**
                 * Remove filter
                 *
                 * @param name
                 */
                removeFilter(name) {
                    this.fetchParams[translations.page] = 1;
                    delete this.fetchParams[name];

                    this.updateActiveFiltersInUrl();
                    this.fetchPublications(false, true);
                },
                /**
                 * remove filter value
                 *
                 * @param name
                 * @param value
                 */
                removeFilterValue(name, value) {
                    const index = this.fetchParams[name].indexOf(value);

                    if (index > -1) {
                        this.fetchParams[translations.page] = 1;
                        this.fetchParams[name].splice(index, 1);
                        this.updateActiveFiltersInUrl();
                        this.fetchPublications(false, true);
                    }
                },
                /**
                 * Open in new tab
                 * @param url
                 */
                openInNewTab(url) {
                    window.open(url, '_blank').focus();
                },
                scrollToTop() {
                    this.$el.scrollIntoView();
                },
                /**
                 * Update the url width the active filters
                 */
                updateActiveFiltersInUrl() {
                    const url = (new URL(window.location.origin + window.location.pathname));

                    Object.keys(this.fetchParams).forEach(filterName => {
                        const filterValue = this.fetchParams[filterName];
                        if (! filterValue) {
                            return;
                        }

                        if (Array.isArray(filterValue)) {
                            if (! filterValue.length) {
                                return;
                            }
                            url.searchParams.append(filterName, filterValue.join(','));
                        } else {
                            url.searchParams.append(filterName, filterValue);
                        }
                    });

                    window.history.pushState({},null, url.toString());
                },
                /**
                 * Initialize current filters
                 * Get the current filters from the url and apply them
                 */
                initializeCurrentFilters() {
                    const urlParams = new URLSearchParams(document.location.search);

                    this.fetchParams['kleur'] = urlParams.get('kleur') || '';
                    this.fetchParams['structuur'] = urlParams.get('structuur') || '';
                    this.fetchParams['formaat'] = urlParams.get('formaat') || '';
                }
            },
            async mounted() {
                this.blockId = this.$el.closest('[data-block-id]').dataset.blockId;
                this.initialized = true;
                this.loader = this.$refs.loader ? (new Loader(this.$refs.loader)) : null;
            },
            created() {
                this.initializeCurrentFilters();
            },
            beforeDestroy() {
                window.removeEventListener("popstate", this.initializeCurrentFilters);
            }
        });

        app.config.compilerOptions.delimiters = ['v{', '}'];


        // mount the app
        app.mount(this.$list);
    }
}